import { type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError;

export type QueryKey = [EQueryKeys.ModerationComplainFrontend__V1_GetModerationComplainMicrofrontend];

export const getQueryKey = (): QueryKey => [
  EQueryKeys.ModerationComplainFrontend__V1_GetModerationComplainMicrofrontend,
];
